import { actionTypeKeys } from "./actionTypeKeys";
import { Dispatch } from "redux";
import { Customer, CustomerInfoDto } from "../types/customer";
import CustomersApi from "../api/customersApi";
import { setAppTitleBar } from "./appTitleBarActions";
import RepresentativesApi from "../api/representativesApi";

export const authenticationSuccess = (customer: Customer) => {
  return {
    type: actionTypeKeys.AUTHENTICATION_SUCCESS,
    customer
  };
};

export const guestSignin = () => {
  return {
    type: actionTypeKeys.GUEST_SIGN_IN
  };
};

export const authenticationError = (error: any) => {
  return {
    type: actionTypeKeys.AUTHENTICATION_FAILED,
    error
  };
};

export const logoutSuccess = () => {
  return {
    type: actionTypeKeys.LOGOUT_SUCCESS
  };
};

export const signInServiceRepSuccess = (email: string) => {
  return {
    type: actionTypeKeys.SERVICE_REP_SIGN_IN_SUCCESS,
    email
  };
};

export const appointmentCreatedBy = (name: string) => {
  return {
    type: actionTypeKeys.APPT_CREATED_BY,
    name
  };
};

export const signInFirstTimeGuest = () => {
  return (dispatch: Dispatch) => {
    dispatch(guestSignin());
  };
};

export const validateCustomer = (info: CustomerInfoDto, persist: boolean = true) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const customer = await CustomersApi.validateCustomer(info);
      if (persist) {
        sessionStorage.setItem("customer", JSON.stringify(customer));
      }
      dispatch(authenticationSuccess(customer));
      return true;
    } catch (error) {
      dispatch(authenticationError(error));
      return false;
    }
  };
};

export const signInServiceRep = (email: string) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const valid = await RepresentativesApi.validateRepresentative(email);
      if (valid) {
        dispatch(signInServiceRepSuccess(email));
        dispatch(appointmentCreatedBy(email));
      }
      return valid;
    } catch (error) {
      dispatch(authenticationError(error));
      return false;
    }
  };
};

export const logout = (dispatch: Dispatch) => {
  sessionStorage.removeItem("customer");
  dispatch(logoutSuccess());
  dispatch(setAppTitleBar({ description: "", title: "" }));
};
